'use client';

import * as React from 'react';
import { styled } from '@linaria/react';

import useWindowDimensions from '@/hooks/use-window-dimensions';

import Demo, { DemoSliderControl } from '@/components/Demo';

import Synthesizer from '../Synthesizer';

const SYNTH_WIDTH = 512;
const TOTAL_WIDTH = SYNTH_WIDTH + 16 * 2;

function SynthLayersDemo() {
  // So our synth is a hardcoded 512px wide, which means it won’t fit on mobile. We’ll calculate how much it would spillover by, and use transform:scale to shrink it proportionally, so that it always fills the available space but no more.
  const windowDimensions = useWindowDimensions();
  let scale = 1;

  if (
    windowDimensions?.width &&
    windowDimensions.width < TOTAL_WIDTH
  ) {
    const spillover = (windowDimensions.width - TOTAL_WIDTH) * -1;
    scale = 1 - spillover / SYNTH_WIDTH;
  }

  return (
    <Demo
      id="synth-gradient-demo"
      initialValues={{
        layers: 0,
      }}
      outputWrapper={null}
      controls={[
        <DemoSliderControl
          id="layers"
          key="layers"
          label="Layers"
          min={0}
          max={10}
          step={1}
        />,
      ]}
      customGrid={{
        gridTemplateColumns: 'min(400px, 100%)',
        justifyContent: 'center',
      }}
    >
      {({ layers }) => {
        return (
          <Wrapper style={{ transform: `scale(${scale})` }}>
            <Synthesizer layers={layers} />
          </Wrapper>
        );
      }}
    </Demo>
  );
}

const Wrapper = styled.div`
  transform-origin: left center;
`;

export default SynthLayersDemo;
